import { Injectable, Injector } from '@angular/core';
import { Auth, signOut, user, User } from '@angular/fire/auth';
import { AppUser, IAppUser } from '../../models/app-user.model';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from '../spinner/spinner.service';
import { Router } from '@angular/router';
import { ToastService } from '../toast/toast.service';
import { Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IServerResponse, ServerResponse } from '../../models/server-response.model';
import { MessagingService } from '../messaging/messaging.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public loggedIn: boolean = false;
  public loadingAppUser: boolean = false;

  public currentFirebaseUser?: User;

  public currentUser?: AppUser;
  public subCurrentUser: Subject<AppUser> = new Subject<AppUser>();

  constructor(
    public auth: Auth,
    private http: HttpClient,
    private spinnerService: SpinnerService,
    private router: Router,
    public toastService: ToastService,
    private injector: Injector
  ) {

    user(this.auth).subscribe((_user: any) => {
      if (_user) {
        console.log('Existe usuario');
        
        this.loggedIn = true;
        this.currentFirebaseUser = _user;
        
        if(!this.currentUser && !this.loadingAppUser) {         

          this.getUser();
        }
        
      } else {
        console.log('NO Existe usuario');
        this.loggedIn = false;
      }
    });

  }

  /* -------------------------------------------------------------------------- */
  /*                           ANCHOR getFirebaseUser                           */
  /* -------------------------------------------------------------------------- */
  // region getFirebaseUser
  async getFirebaseUser(): Promise<User | null> {
    return new Promise((resolve, reject) => {
      
      if(this.currentFirebaseUser) {
        resolve(this.currentFirebaseUser);
      } else {
        user(this.auth).subscribe((_user: any) => {
          if (_user) {
            console.log('Existe usuario');
            
            this.loggedIn = true;
            this.currentFirebaseUser = _user;
            // this.getUser();
            resolve(_user);
          } else {
            console.log('NO Existe usuario');
            this.loggedIn = false;
            resolve(null);
          }
        });
      }

    });
    
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR getToken                              */
  /* -------------------------------------------------------------------------- */
  // region getToken
  async getToken(): Promise<string> {
    const user = await this.getFirebaseUser();

    const token = await user?.getIdToken();
    
    return token ?? '';
  }

  async signOut() {
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cerrando sesión';

    // Eliminar el registro de notificaciones push ANTES del signOut de
    // Firebase (despues ya no hay token de autenticacion para el DELETE)
    try {
      await this.injector.get(MessagingService).unregister();
    } catch(error) {
      console.log('Error al eliminar dispositivo de notificaciones: ', error);
    }

    await signOut(this.auth);

    this.currentUser = undefined;

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    sessionStorage.removeItem('user');
    this.loggedIn = false;
    this.router.navigate(['login']);
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR getUser                               */
  /* -------------------------------------------------------------------------- */
  // region getUser
  async getUser() {
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cargando datos de usuario';

    this.loadingAppUser = true;

    const token = await this.currentFirebaseUser?.getIdToken();
    // console.log('token: ', token);
    
    const urlApi = `${environment.urlApi}/account`;

    try {

      const response = await new Promise<ServerResponse<{ user: IAppUser }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ user: IAppUser }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token ?? ''
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ user: IAppUser }>
              ) => resolve(
                new ServerResponse<{ user: IAppUser }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        this.currentUser = new AppUser(
          response.data?.user!
        );

        this.subCurrentUser.next(this.currentUser);

        // Registrar dispositivo para notificaciones push (fire-and-forget,
        // no bloquea la carga de la sesion; errores manejados internamente)
        this.injector.get(MessagingService).register();
      }

      console.log(
        this.currentUser,
      );
      

    } catch(error) {
      console.log(error);
    }

    this.loadingAppUser = false;
    this.spinnerService.loading = false;
    this.spinnerService.message = '';
  }

}
